import React from 'react';

import styled from 'styled-components';

import ConfirmModal from 'common/Modal/ConfirmModal';
import TextArea from 'components/lib/TextArea';

const DeleteReasonContainer = styled.div`
  width: 100%;
  margin-top: 24px;
`;

const DeleteReasonLabel = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
`;

type Props = {
  open: boolean;
  planName: string;
  loading?: boolean;
  reason: string;
  onReasonChange: (value: string) => void;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
};

const ActionPlanDeleteWithReasonModal = ({
  open,
  planName,
  loading = false,
  reason,
  onReasonChange,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <ConfirmModal
      open={open}
      title="Delete AI Action Plan?"
      description={`You are about to delete the AI action plan '${planName}'. This plan was AI-generated. Tell us why it missed so we can improve your next recommendations.`}
      confirmLabel="Delete & Submit Feedback"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <DeleteReasonContainer>
        <DeleteReasonLabel>What didn't work about this plan? (Optional)</DeleteReasonLabel>
        <TextArea
          rows={3}
          placeholder="e.g. not relevant, already doing this, too vague..."
          value={reason}
          style={{ marginBottom: '15px' }}
          onChange={(event) => onReasonChange(event.target.value)}
        />
      </DeleteReasonContainer>
    </ConfirmModal>
  );
};

export default ActionPlanDeleteWithReasonModal;
